import { Paper, type PaperProps } from '@mantine/core';
import type { ReactNode } from 'react';

export function DataPanel({ children, ...props }: PaperProps & { children: ReactNode }) {
    return (
        <Paper p="md" radius="lg" withBorder shadow="xs" {...props}>
            {children}
        </Paper>
    );
}
